var React = require('react');

function Fb (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8 0C8 0 7.75001 0 6.66667 0C4.27084 0 2.65625 1.54018 2.66667 4.28571V7.14285H0V9.99999H2.65625L2.66667 20H5.33333V9.99999H7.6L8 7.14285H5.33333V4.6875C5.33333 2.85714 6.09559 2.85714 7.36459 2.85714H8V0Z"}));
}

Fb.defaultProps = {"width":"8","height":"20","viewBox":"0 0 8 20","fill":"none"};

module.exports = Fb;

Fb.default = Fb;
